import { fetch } from 'whatwg-fetch';
import { getAccessToken } from '../utils/access-token-storage';
import Config from '../constants/Config';

const http = {};

function buildQuery(data) {
  if (!data) return '';
  const params = Object.entries(data)
    .filter(([_, value]) => value !== null && value !== undefined)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&');
  return params ? `?${params}` : '';
}
// TODO: add all methods
['POST', 'GET', 'DELETE', 'PATCH'].forEach((method) => {
  http[method.toLowerCase()] = (url, data, headers) => {
    const token = getAccessToken();
    if (token) {
      headers = {
        ...headers,
        Authorization: `Bearer ${token}`,
      };
    }
    let fetchOptions = {
      method,
      headers,
    };
    if ((method === 'POST' || method === 'PATCH') && data) {
      const reqData = Object.keys(data).reduce((result, key) => {
        result.append(key, data[key]);
        return result;
      }, new FormData());
      fetchOptions.body = reqData;
    } else if ((method === 'GET' || method === 'DELETE') && data) {
      url += buildQuery(data);
    }

    return fetch(`${Config.SERVER_BASE_URL}/api${url}`, fetchOptions)
      .then((response) =>
        response.json().then((body) => ({
          body,
          isError: response.status !== 200,
        })),
      )
      .then(({ body, isError }) => {
        if (isError) {
          throw body;
        }
        return body;
      });
  };
});

export default http;
